import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  { key: 'locationName', header: 'Location', type: 'text', width: 45 },
  {
    key: 'totalRevenue',
    header: 'Annual Revenue Supported',
    type: 'money',
    width: 45,
  },
  {
    key: 'processAreas',
    header: 'Process Areas',
    type: 'number',
    width: 45,
  },
  {
    key: 'processes',
    header: 'Processes',
    type: 'number',
    width: 45,
  },
];
